// extracted by mini-css-extract-plugin
export default {"project":"Project_project__IctSr","title":"Project_title__yS79k","tab":"Project_tab__84F5P","active":"Project_active__-2pmw"};